import { Grid, Typography } from "@mui/material";
import MainTitle from "../muiHome/mainTitle";

const SAHSAlumni=()=>{
return (
<Grid container spacing={2}> 

    <Grid item xs={12}>
    <MainTitle title="Our Alumni" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    Our alumni stand as living testaments to the unwavering spirit and excellence embodied by the School of Law at MVN University. They have made a name for themselves as trailblazers in every sector of the legal world, from industry heavyweights to innovative new ventures, and their influence spans the entire sphere. In this area, we will honour their outstanding accomplishments, share their motivational stories, and encourage them to reach out to others in our growing alumni network. Graduates not only demonstrate the value of our school's instruction and support via their achievements, but they also act as role models for students both here and abroad. They leave a legacy of innovation and distinction via their influence in law field, leadership in other fields, and continued engagement with our institution, which enriches our community. So that our alums can continue to play a significant role in our story as it develops, we also provide information on alumni events, networking opportunities, and ways to give back.
    <br/><br/>
    </Typography>
    </Grid>


    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        <div className="our_alumni_list">
                <div className="row">
                    <div className="col-md-3">
                        <div className="one_alumit  ">
                            <div class="testimonial-data">
                                <label><img width="150" height="150" src="/assets/img/alumi/chankya_sharma_01.jpg" class="attachment-thumbnail size-thumbnail wp-post-image" alt="" decoding="async" loading="lazy" /></label>
                                <h4><b>CHANKYA SHARMA</b></h4>
                                <span class="testimony-deg">Batch: BALLB(17-22)B</span>
                                <p>Current status:  Working as legal manager in arkiis e-services pvt. Ltd(gurugram)</p>
                            </div> 
                        </div> 
                    </div>

                    <div className="col-md-3">
                        <div className="one_alumit  ">
                            <div class="testimonial-data">
                                <label><img width="150" height="150" src="/assets/img/alumi/dummy.jpg" class="attachment-thumbnail size-thumbnail wp-post-image" alt="" decoding="async" loading="lazy" /></label>
                                <h4><b>PREETI</b></h4>
                                <span class="testimony-deg">Batch: LLM(2023)</span>
                                <p> </p>
                            </div> 
                        </div> 
                    </div>


                    <div className="col-md-3">
                        <div className="one_alumit  ">
                            <div class="testimonial-data">
                                <label><img width="150" height="150" src="/assets/img/alumi/preeti01.jpg" class="attachment-thumbnail size-thumbnail wp-post-image" alt="" decoding="async" loading="lazy" /></label>
                                <h4><b>PREETI</b></h4>
                                <span class="testimony-deg">Batch: LLB(20-23)</span>
                                <p>Current status:  Working in mvn infra</p>
                            </div> 
                        </div> 
                    </div>

                    <div className="col-md-3">
                        <div className="one_alumit  ">
                            <div class="testimonial-data">
                                <label><img width="150" height="150" src="/assets/img/alumi/pranjal_raghav01.jpg" class="attachment-thumbnail size-thumbnail wp-post-image" alt="" decoding="async" loading="lazy" /></label>
                                <h4><b>PRANJAL RAGHAV</b></h4>
                                <span class="testimony-deg">Batch: BBALLB(18-23)</span>
                                <p>Current status:  Working in mvn infra</p>
                            </div> 
                        </div> 
                    </div>

                    <div className="col-md-3">
                        <div className="one_alumit  ">
                            <div class="testimonial-data">
                                <label><img width="150" height="150" src="/assets/img/alumi/atishay_jain02.jpg" class="attachment-thumbnail size-thumbnail wp-post-image" alt="" decoding="async" loading="lazy" /></label>
                                <h4><b>ATISHAY JAIN</b></h4>
                                <span class="testimony-deg">Batch: LLB(21-23)</span>
                                <p>Current status:  Established a legal firm</p>
                            </div> 
                        </div> 
                    </div>

                    <div className="col-md-3">
                        <div className="one_alumit  ">
                            <div class="testimonial-data">
                                <label><img width="150" height="150" src="/assets/img/alumi/rohan_gaur01.jpg" class="attachment-thumbnail size-thumbnail wp-post-image" alt="" decoding="async" loading="lazy" /></label>
                                <h4><b>ROHAN GAUR</b></h4>
                                <span class="testimony-deg">Batch: BALLB(20-25)</span>
                                <p>Current status:  Working in mvn infra as legal trainee</p>
                            </div> 
                        </div> 
                    </div>

                    <div className="col-md-3">
                        <div className="one_alumit  ">
                            <div class="testimonial-data">
                                <label><img width="150" height="150" src="/assets/img/alumi/mohit01.jpg" class="attachment-thumbnail size-thumbnail wp-post-image" alt="" decoding="async" loading="lazy" /></label>
                                <h4><b>MOHIT</b></h4>
                                <span class="testimony-deg">Batch: BBALLB(20-25)</span>
                                <p>Current status:  Working in mvn infra as management trainee</p>
                            </div> 
                        </div> 
                    </div>

                    <div className="col-md-3">
                        <div className="one_alumit  ">
                            <div class="testimonial-data">
                                <label><img width="150" height="150" src="/assets/img/alumi/partha01.jpg" class="attachment-thumbnail size-thumbnail wp-post-image" alt="" decoding="async" loading="lazy" /></label>
                                <h4><b>PARTHA</b></h4>
                                <span class="testimony-deg">Batch: BBALLB(20-25)</span>
                                <p>Current status:  Working in mvn infra as management trainee</p>
                            </div> 
                        </div> 
                    </div>


                    <div className="col-md-3">
                        <div className="one_alumit  ">
                            <div class="testimonial-data">
                                <label><img width="150" height="150" src="/assets/img/alumi/tabitha01.jpg" class="attachment-thumbnail size-thumbnail wp-post-image" alt="" decoding="async" loading="lazy" /></label>
                                <h4><b>TABITHA</b></h4>
                                <span class="testimony-deg">Batch: BBALLB(20-25)</span>
                                <p>Current status:  Working in mvn infra as management trainee</p>
                            </div> 
                        </div> 
                    </div>


                    <div className="col-md-3">
                        <div className="one_alumit  ">
                            <div class="testimonial-data">
                                <label><img width="150" height="150" src="/assets/img/alumi/dummy.jpg" class="attachment-thumbnail size-thumbnail wp-post-image" alt="" decoding="async" loading="lazy" /></label>
                                <h4><b>YASHVINDER RAWAT</b></h4>
                                <span class="testimony-deg">Batch: BBALLB(16-21)</span>
                                <p>Current status:  Senior investment advisor unique properties,dubai</p>
                            </div> 
                        </div> 
                    </div>


                    <div className="col-md-3">
                        <div className="one_alumit  ">
                            <div class="testimonial-data">
                                <label><img width="150" height="150" src="/assets/img/alumi/mukesh01.jpg" class="attachment-thumbnail size-thumbnail wp-post-image" alt="" decoding="async" loading="lazy" /></label>
                                <h4><b>MUKESH</b></h4>
                                <span class="testimony-deg">Batch: LLM(2018)</span>
                                <p>Current status:  Sdjm, Motihari, Bihar 30th Bjs(Rank 38)</p>
                            </div> 
                        </div> 
                    </div>

                    <div className="col-md-3">
                        <div className="one_alumit  ">
                            <div class="testimonial-data">
                                <label><img width="150" height="150" src="/assets/img/alumi/rishabh_jain01.jpg" class="attachment-thumbnail size-thumbnail wp-post-image" alt="" decoding="async" loading="lazy" /></label>
                                <h4><b>RISHABH JAIN</b></h4>
                                <span class="testimony-deg">Batch: BALLB(20-25)</span>
                                <p>Current status: Junior intern at anand awasthi and associates</p>
                            </div> 
                        </div> 
                    </div>


                    <div className="col-md-3">
                        <div className="one_alumit  ">
                            <div class="testimonial-data">
                                <label><img width="150" height="150" src="/assets/img/alumi/shiv_dutt_sharma.jpg" class="attachment-thumbnail size-thumbnail wp-post-image" alt="" decoding="async" loading="lazy" /></label>
                                <h4><b>SHIV DUTT SHARMA</b></h4>
                                <span class="testimony-deg">Batch: LLB(20-23)</span>
                                <p>Current status: Founder & CEO
Shivlok Legal India Pvt. Ltd.
Product: India Court - AI-based Legal Awareness Platform
</p>
                            </div> 
                        </div> 
                    </div>

                      <div className="col-md-3">
                        <div className="one_alumit  ">
                            <div class="testimonial-data">
                                <label><img width="150" height="150" src="/assets/img/alumi/jagvir_sorout01.jpg" class="attachment-thumbnail size-thumbnail wp-post-image" alt="" decoding="async" loading="lazy" /></label>
                                <h4><b>JAGVIR SOROUT</b></h4>
                                <span class="testimony-deg">Batch: LLB(17-20)</span>
                                <p>Current status: Practicing advocate at district courts at palwal, faridabad, nuh
</p>
                            </div> 
                        </div> 
                    </div>
                    







                </div>
        </div>
    </Typography>
    </Grid>


    </Grid>

)
}
export default SAHSAlumni;